import React, { useContext, useEffect, useState } from 'react'
import SmallModal from '../../../../../components/Modals/SmallModal'
import {
  Alert,
  Button,
  Modal,
  Stack,
  TextField,
  Typography,
} from '@mui/material'
import SendIcon from '@mui/icons-material/Send'
import API from '../../../../../services/API'
import { GlobalContext, UserContext } from '../../../../../App'
import moment from 'moment'

const ComposeMessage = ({ open, onClose, eventID, setMessages }) => {
  const [newMessage, setNewMessage] = useState('')

  const { user } = useContext(UserContext)
  const { setToast } = useContext(GlobalContext)

  useEffect(() => {
    return () => setNewMessage('')
  }, [open])

  const handleSubmit = (e) => {
    e.preventDefault()
    API.post('/client-portal/event/message', {
      newMessage,
      eventID,
    }).then((res) => {
      if (res.status === 200) {
        setMessages((prev) => [
          ...prev,
          {
            date: moment(),
            by: {
              firstName: user.firstName,
              lastName: user.lastName,
              employee: true,
            },
            comment: newMessage,
            _id: Math.random(),
          },
        ])
        onClose()
        setToast({
          message: 'Message Sent Successfully',
        })
      }
    })
  }
  return (
    <Modal open={open} onClose={onClose}>
      <Stack
        gap={1}
        component="form"
        onSubmit={handleSubmit}
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '400px',
          maxWidth: '80vw',
          bgcolor: 'background.paper',
          borderRadius: 1,
          boxShadow: 24,
          borderColor: 'none',
          maxHeight: 500,
          overflow: 'auto',
          padding: 1,
          outline: 'none',
        }}
      >
        <Typography variant="title3" textAlign="center">
          New Message
        </Typography>
        <TextField
          value={newMessage}
          onChange={(e) => setNewMessage(e.target.value)}
          minRows={3}
          multiline
          required
        />
        <Alert severity="info">
          Please be aware that the Medical Provider does not currently receive
          notifications about new messages. Please contact them directly if your
          message is urgent.
        </Alert>
        <Button
          type="submit"
          color="success"
          fullWidth
          variant="contained"
          endIcon={<SendIcon />}
        >
          Send
        </Button>
      </Stack>
    </Modal>
  )
}

export default ComposeMessage
